<template>
  <!-- 地址列表组件 -->
  <div id="addressList" :class="isOpenClose ? 'open-close' : ''">
    <div class="header">
      <div class="title">确认收货信息</div>
      <div class="addBtn" @click="addAddress">
        <el-icon class="el-icon-plus"></el-icon>
        <span>新增收货地址</span>
      </div>
    </div>
    <div class="addressWrap" ref="addressWrapRef">
      <div class="list" ref="listRef">
        <div
          v-for="(item,index) of detailList"
          :key="index"
          class="items"
          :class="chooseId==item.id?'chooseItem':''"
          @click="changChooseId(item.id)"
        >
          <div class="topWrap">
            <div class="firstRow">
              <span class="name"> {{ item.name }}</span>
              <!-- <span class="phone">{{ item.tel | isPoneMatch }}</span> -->
              <span class="phone">{{ item.tel }}</span>
              <span class="default" v-if="item.isDefault">默认</span>
            </div>
            <div class="twoRow">
              <span class="addressInfo">{{ item.address }}</span>
            </div>
          </div>
          <div class="threeRow">
            <span v-if="!item.isDefault" @click.stop="changDefault(item)">设为默认</span>
            <span @click.stop="modifyAdd(item.id)">编辑</span>
            <span v-if="!item.isDefault" @click.stop="deleteAddress(item.id)">删除</span>
          </div>
        </div>
        <!-- <div class="items lastItem" @click="addAddress">
          <img src="../../assets/images/addIcon.png" class="addBtn">
          <div class="names">使用新地址</div>
        </div> -->
      </div>
    </div>
    <div class="address-open-close" v-if="isShowOpenClose">
      <span class="address-open" v-if="!isOpenClose" @click="handleChangeIsOpen">点击展开<el-icon class="el-icon-arrow-down"></el-icon></span>
      <span class="address-close" v-else @click="handleChangeIsOpen">点击关闭<el-icon class="el-icon-arrow-up"></el-icon></span>
    </div>
    <addressPop ref="addressDia" @complate="complateAddress" />
  </div>
</template>
<script>
/*global BaseApi */
import addressPop from './addressPop.vue'
export default {
  name: 'AddressList',
  components: {
    addressPop
  },
  props: {
    chooseAddId: {
      require: false,
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      isShowNoData: false,
      isAddressLoading: true,
      threeList: [],
      detailList: [],
      chooseId: null,
      startIndex: 0,
      endIndex: 3,
      isOpenClose: false,
      isShowOpenClose: false
    }
  },
  watch: {
    chooseAddId(val) {
      this.chooseId = val
      for (let i = 0; i < this.detailList.length; i++) {
        // 进入地址是选择的是第二页的判断
        if (this.detailList[i].id == this.chooseId) {
          this.startIndex = Math.floor(i / 3) * 3
          this.endIndex = Math.floor(this.startIndex + 3)
        }
      }
    }
  },
  mounted() {
    this.queryFirmAddress()
  },
  methods: {
    // 切换展开关闭
    handleChangeIsOpen() {
      this.isOpenClose = !this.isOpenClose
    },
    // 获取收货地址
    queryFirmAddress() {
      var that = this
      BaseApi.getUserAddress({}).then((response) => {
        // eslint-disable-next-line no-unused-vars
        const { value, message, code } = response.data
        that.isAddressLoading = false
        if (Number(code) === 0) {
          if (value.length !== 0) {
            for (let i = 0; i < value.length; i++) {
              const item = value[i]
              item.name = item.recipients
              item.tel = item.recipientsCellphone
              item.isDefault = item.defaultFlag
              item.address = item.addressName
              item.id = item.addressId
              that.detailList.push(item)
              // 进入地址是选择的是第二页的判断
              // if (item.id == that.chooseId) {
              //   that.startIndex = Math.floor(i / 3) * 3
              //   that.endIndex = Math.floor(that.startIndex + 3)
              // }
              if (item.defaultFlag) {
                sessionStorage.setItem('defaultAddress', JSON.stringify(item))
              }
            }
            this.isOpenClose = false
            // 数据加载完成后，检查是否有传入的 chooseAddId
            if (this.chooseAddId) {
              this.chooseId = this.chooseAddId
            }
            this.$nextTick(() => {
              this.isShowOpenClose = this.$refs.addressWrapRef.clientHeight < this.$refs.addressWrapRef.scrollHeight
            })
          } else {
            that.isShowNoData = true
          }
        } else {
          // eslint-disable-next-line no-undef
          this.$message(message)
        }
      })
    },
    addAddress() {
      const params = {
        isAdd: 'add'
      }
      this.$refs.addressDia.openDialog(params)
    },
    complateAddress() {
      this.detailList = []
      this.queryFirmAddress()
      this.$emit('changAddId', this.chooseId)
    },
    changChooseId(id) {
      this.chooseId = id
      this.$emit('changAddId', id)
    },
    modifyAdd(id) {
      const params = {
        isAdd: 'modify',
        modifyId: id
      }
      this.$refs.addressDia.openDialog(params)
    },
    changDefault(item) {
      // 改变是否默认地址
      // if (item.isDefault === true) {
      const sendValue = {
        'addressId': item.id,
        'addressName': item.address, // 收货地址
        'defaultFlag': 1, // 是否设置为默认收获地址 (0:否 1:是)
        'postCode': item.postCode, // 邮政编码
        'recipients': item.name, // 收货人
        'recipientsCellphone': item.tel, //	收货人电话
        'region': item.region // 地区(前端维护辅助字段)
      }
      const that = this
      BaseApi.updateUserAddress(sendValue).then(response => {
        const { code, message } = response.data
        this.$message(message)
        if (code === 0 || code === '0') {
          that.detailList.forEach((ele) => {
            // eslint-disable-next-line eqeqeq
            if (ele.addressId == item.addressId) {
              ele.isDefault = 1
              sessionStorage.setItem('defaultAddress', JSON.stringify(ele))
            } else {
              ele.isDefault = 0
            }
          })
        }
      })
    },
    deleteAddress(id) {
      const that = this
      const addressId = {
        addressId: id
      }
      BaseApi.deleteUserAddress(addressId).then(response => {
        const { code, message } = response.data
        // eslint-disable-next-line eqeqeq
        if (code == 0) {
          this.detailList = []
          that.queryFirmAddress()
        } else {
          this.$message(message)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#addressList{
    margin: 0 auto;
    width: 1200px;
    height: 160px;
    background: #ffffff;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    &.open-close {
      height: auto;
      padding-bottom: 53px;
    }
    .header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #ffffff;
      height: 40px;
      padding: 0 10px;
      box-sizing: border-box;
      .title{
        font-size: 14px;
        font-family: PingFang TC-Medium;
        font-weight: 500;
        color: #333333;
      }
      .addBtn{
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 14px;
        font-family: PingFang TC-Medium;
        color: #333333;
        line-height: 24px;
        height: 24px;
        width: 110px;
        text-align: center;
        background: #F4F4F4;
        /deep/.el-icon-plus {
          font-size: 12px;
          color: #333333;
          font-weight: bold;
        }
      }
    }
    .addressWrap{
      padding: 0 10px;
      box-sizing: border-box;
      height: calc(100% - 40px - 54px);
      overflow: hidden;
      .list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .items{
          width: 585px;
          height: 66px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #cccccc;
          background: #ffffff;
          padding: 10px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          &:nth-child(n+3) {
            margin-top: 10px;
          }
          &.chooseItem{
            border: 1px solid #EB6643;
          }
        }
        .topWrap{
          .firstRow{
            position: relative;
            .name{
              font-size: 14px;
              font-family: PingFang TC-Medium;
              color: #333333;
              line-height: 18px;
            }
            .phone{
              margin-left: 10px;
              display: inline-block;
              font-size: 14px;
              font-family: PingFang TC-Medium;
              font-weight: normal;
              color: #333333;
              line-height: 18px;
            }
            .default {
              display: inline-block;
              background: #F4F4F4;
              width: 38px;
              line-height: 18px;
              text-align: center;
              font-size: 12px;
              border-radius: 5px;
              margin-left: 6px;
            }
          }
          .twoRow{
            font-size: 12px;
            font-family: PingFang TC-Medium;
            font-weight: 400;
            line-height: 20px;
            display: flex;
            margin-top: 5px;
            .addressInfo{
              color: #999999;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              line-clamp: 4;
              -webkit-box-orient: vertical;
              border-radius: 4px;
            }
          }
        }
        .threeRow{
          text-align: right;
          font-size: 12px;
          font-family: PingFang TC-Medium;
          font-weight: 400;
          color: #999999;
          line-height: 18px;
          position: relative;
          span{
            display: inline-block;
            padding-left: 10px;
            color: #999999;
            position: relative;
            cursor: pointer;
          }
          // span::after{
          //   content:'';
          //   position: absolute;
          //   right:0;
          //   top:4px;
          //   width:1px;
          //   height: 14px;
          //   background: #6F7181;
          // }
          // span:last-child::after{
          //   display: none;
          // }
        }
      }
    }
    .address-open-close {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
      user-select: none;
      color: #333333;
      bottom: 10px;
      .address-open {
        cursor: pointer;
        .el-icon-arrow-down {
          font-size: 12px;
        }
      }
      .address-close {
        cursor: pointer;
        .el-icon-arrow-up {
          font-size: 12px;
        }
      }
    }
}
</style>
